module.exports = __webpack_public_path__ + "1dba73335c6b83f4a29d65d38a86eeaa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category_4.png
// module id = ./assets/images/category_4.png
// module chunks = 0